import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ClipboardImageHandler from '../common/form/ClipboardImageHandler'

import {
	setModoTela, initForm
} from './videoActions';

class VideoForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir || this.props.visualizacao ? 'readOnly' : '';

		
		return (
			<Row alignCenter>
				<Grid cols='12 10 8 5'>
					<ContentCard style={{ backgroundColor: '#63c8c3' }}>
						<Form event={this.props.handleSubmit}>
							<ContentCardBody>
								<Row>

									<Field
										name='trilha'
										component={Select}
										label='Trilha: *' placeholder=''
										cols='12 12 12 12'
										options={this.props.listaVideoTrilha}
										readOnly={readOnly} />
									
									<Field
										name='nome'
										component={LabelAndInput}
										label='Nome: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />

									<Field
										name='professor'
										component={LabelAndInput}
										label='Professor(a): *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
										
									<Field
										name='conteudo'
										component={LabelAndTextarea}
										label='Conteúdo: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='contato'
										component={LabelAndInput}
										label='Contato: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='link'
										component={LabelAndInput}
										label='Link: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									 
								</Row>

								<Row alignCenter>
									{!this.props.visualizacao &&
									<Grid cols='8 8 8 8'>
										{this.props.excluir ? (
											<Button
												text='Excluir'
												submit type={'danger'}
												icon={'fa fa-trash'} />
										) : (
										<Button
											text='Salvar'
											submit
											type={'success'}
											icon={'fa fa-check'} />
										)}
									</Grid>}
									<Grid cols='4 4 4 4'>
										<Button
											text='Voltar'
											type={'success'}
											icon={'fa fa-chevron-left'}
											event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
									</Grid>
								</Row>
							</ContentCardBody>
						</Form>
					</ContentCard>
				</Grid>
			</Row>
		);
    }


}

VideoForm = reduxForm({form: 'videoForm', destroyOnUnmount: false})(VideoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('videoForm')(state),
	registro: state.video.registro,
	lista: state.video.lista,
	listaVideoTrilha: state.video.listaVideoTrilha
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(VideoForm);
